import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import {
  RevenueBreakdownParams,
  RevenueBreakdownResponse
} from "../financialReport.types";

export const requestRevenueBreakdown = async (
  params: RevenueBreakdownParams
): Promise<RevenueBreakdownResponse> => {
  return await instance.get(ApiRoutesFinancialReport.RevenueBreakdown, {
    params
  });
};
